import React from 'react'
import {
	Table,
	Button
} from 'reactstrap'
import Reflux from 'reflux'
import _ from 'lodash'

import CurrentRecipeActions from '~/actions/currentRecipe.js'
import CurrentRecipeStore from '~/stores/currentRecipe.js'

import RecipeInstructionsEditRow from '~/modules/recipeInstructions/editRow.jsx'
import CoreSimpleTextbox from 'core/simpleTextbox.jsx'


export default class RecipeInstructionsEdit extends Reflux.Component {
	constructor(props) {
		super(props)

		this.state = {
			instruction: ''
		}

		this.store = CurrentRecipeStore
		this.storeKeys = [
			'recipeInstructions'
		]
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	addStepToRecipe = () => {
		CurrentRecipeActions.addInstruction(
			this.state.instruction,
			() => {
				this.setState({
					instruction: ''
				})
			}
		)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	handleChangeField = (event) => {
		this.setState({ [event.target.name]: event.target.value })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const theInstructions = (
			_.has(this.state, 'recipeInstructions')
			&& _.isArray(this.state.recipeInstructions)
			&& _.size(this.state.recipeInstructions) > 0
		)
			? this.state.recipeInstructions.map(
				(theInstruction, theIndex) =>
				<RecipeInstructionsEditRow
					key={theInstruction.recipeInstructionsID}
					index={theIndex}
					recipeInstructionsID={theInstruction.recipeInstructionsID}
					instruction={theInstruction.instruction}
				/>
			)
			: null
		const saveDisabled = (
			this.state.instruction === ''
			|| this.state.instruction === null
		)

		return (
			<form
				onSubmit={(event) => {
					event.preventDefault()

					if (saveDisabled === false) {
						this.addStepToRecipe()
					}
				}}
			>
				<Table size="sm" hover striped style={{ width: '100%' }}>
					<thead>
						<tr>
							<th width="5%" className="text-right">
								Step
							</th>
							<th width="75%">
								Instruction
							</th>
							<th width="10%" />
							<th width="10%" />
						</tr>
					</thead>
					<tbody>
						{theInstructions}
					</tbody>
					<tbody>
						<tr>
							<td />
							<td>
								<CoreSimpleTextbox
									onChange={this.handleChangeField}
									onEnterKey={this.addStepToRecipe}
									maxLength={999}
									name="instruction"
									value={this.state.instruction || ''}
								/>
							</td>
							<td colSpan="2">
								<Button
									color="success"
									onClick={this.addStepToRecipe}
									block
									disabled={saveDisabled}
								>
									Add step
								</Button>
							</td>
						</tr>
					</tbody>
				</Table>
			</form>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipeInstructions/edit.jsx